import { render, staticRenderFns } from "./testmap.vue?vue&type=template&id=d4348746&"
import script from "./testmap.vue?vue&type=script&lang=js&"
export * from "./testmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports